import { v4 as uuid } from "uuid";

interface BuildAdTagOptions {
  networkId: string;
  adUnit: string;
  duration?: number;
  size: string;
}

/**
 * Builds a Google Ad Manager (GAM) ad tag URL for video ads
 *
 * @param options - Configuration options
 * @param options.adUnit - The ad unit path (e.g., "player_video_midroll")
 * @param options.networkId - The GAM network code (defaults to 23325224050)
 * @param options.duration - Duration of the video ad is being requested for
 * @param options.size - List of comma separated ad sizes this unit should accept
 * @returns The complete ad tag URL
 */
export function buildAdTag(opts: BuildAdTagOptions): string {
  const params = new URLSearchParams({
    ad_type: "video",
    iu: `/${opts.networkId}/${opts.adUnit}`,
    tfcd: "0",
    npa: "0",
    sz: opts.size,
    gdfp_req: "1",
    unviewed_position_start: "1",
    output: "vast",
    env: "vp",
    impl: "s",
    correlator: uuid(),
    vad_type: "linear",
    documentation_url: window.location.href,
  });

  if (opts?.duration) {
    params.set("vid_d", opts.duration.toString());
  }

  const urlParams = new URLSearchParams(window.location.search);
  const testAds = urlParams.get("testAds");
  if (testAds) {
    params.set("cust_params", `test%3D${encodeURIComponent(testAds)}`);
  }

  return `https://pubads.g.doubleclick.net/gampad/ads?${params.toString()}`;
}
